export const dc_lang = {
  music: '国际版(ENG)',
  奖金池: '奖金池',
  可参与: '可参与',
  可参赛: '可参赛',
  进行中: '进行中',
  创意赛: '创意赛',
  主办方: '主办方',
  当前阶段:'当前阶段',
  参赛队伍:'参赛队伍',
  参赛人数:'参赛人数',
  作品提交数:'作品提交数',
  竞赛信息:'竞赛信息',
  赛事动态:'赛事动态',
  任务与数据:'任务与数据',
  竞赛圈:'竞赛圈',
  排行榜:'排行榜',
  参赛人员:'参赛人员',
  参赛团队:'参赛团队',
  竞赛背景:'竞赛背景',
  奖项:'奖项',
  时间安排:'时间安排',
  参赛与组队规则:'参赛与组队规则',
  '所有参赛人员及队伍，视为已同意':"所有参赛人员及队伍，视为已同意",
  '《DC竞赛作弊管理规则》':"《DC竞赛作弊管理规则》",
  '及其他相关规定。队长对其队员的参赛行为负责。':"及其他相关规定。队长对其队员的参赛行为负责。",
  '团队人数上限5人' :'团队人数上限 5 人。',

  登录:'登录',
  账号:'账号',
  '请输入用户名/邮箱/手机号':'请输入用户名/邮箱/手机号',
  密码:'密码',
  输入密码:'输入密码',
  立即注册:'立即注册',
  忘记密码:'忘记密码',
  快捷登录:'快捷登录',

  手机找回密码:'手机找回密码',
  使用手机找回:'使用手机找回',
  请输入手机号码:'请输入手机号码',
  验证码:'验证码',
  获取验证码: '获取验证码',
  输入验证码: '输入验证码',
  '新密码（5-16位）':'新密码（5-16位）',
  '5-16位密码':'5-16位密码',
  确认:'确认',
  使用邮箱找回:'使用邮箱找回',
  邮箱找回密码:'邮箱找回密码',
  邮箱地址:'邮箱地址',

  手机号:'手机号',
  请输入手机号:'请输入手机号',
  用户名:'用户名',
  设置用户名称:'设置用户名称',
  '注册即表示你已同意':'注册即表示你已同意',
  '《DC服务规则》':'《DC服务规则》',
  '已有账户？':'已有账户？',
  立即登录:'立即登录',
  邮箱注册:'邮箱注册',
  邮箱:'邮箱',

  团队概况:'团队概况',
  团队名称:'团队名称',
  团队介绍:'团队介绍',
  暂无介绍:'暂无介绍',
  最终排名:'最终排名',
  '未公布/未上榜':'未公布/未上榜',
  团队成员:'团队成员',
  组队情况:'组队情况',
  组队状态:'组队状态',
  开放组队:'开放组队',
  关闭组队:'关闭组队',
  组队邀请:'组队邀请',
  暂无:'暂无',
  需要队友:'需要队友',
  需要技能:'需要技能',

  当前成员:'当前成员',
  在职:'在职',
  暂无荣誉:'暂无荣誉',
  队长:'队长',

  先聊一下:'先聊一下',
  申请组队:'申请组队',
  查看全部参赛队伍:'查看全部参赛队伍',

  关注:'关注',
  粉丝:'粉丝',
  个人:'个人',
  竞赛:'竞赛',
  成就: '成就',
  名人堂积分:'名人堂积分',
  名人堂排名:'名人堂排名',
  性别:'性别',
  学历:'学历',
  学校:'学校',
  专业:'专业',
  角色:'角色',
  技能:'技能',

  已得分提交次数:'已得分提交次数',
  最近提交时间:'最近提交时间',
  请至DC竞赛PC端提交结果:'请至DC竞赛PC端提交结果',
  暂无内容:'暂无内容',

  温馨提示:'温馨提示',
  '暂不支持下载数据，请至DC竞赛PC端下载。':'暂不支持下载数据，请至DC竞赛PC端下载。',
  好的:' 好的',


  '竞赛已结束，无法加入其他队伍，仅可自己创建队伍':'竞赛已结束，无法加入其他队伍，仅可自己创建队伍',
  创建队伍:'创建队伍',
  没有登录:'没有登录',
  去登录:'去登录',
  没有更多了:'没有更多了',
  赞:'赞',
  条评论:'条评论',
  大声说出你的想法吧:'大声说出你的想法吧',
  发送:'发送',
  回复:'回复',

  'DC竞赛-大数据竞赛平台':'DC竞赛-大数据竞赛平台',
  算法赛:'算法赛',
  竞赛已结束:'竞赛已结束',
  '你可以报名参赛，并提交得到排名，但不会获得实物奖励。':'你可以参加报名并提交得到排名，但不会获得实物奖励。',
  报名参赛:'报名参赛',
  '备注：报名参赛或加入队伍后，可获取数据下载权限。':'备注：报名参赛或加入队伍后，可获取数据下载权限。',

  暂无角色:'暂无角色',
  角色未知:'角色未知',
  暂无技能:'暂无技能',
  技能未知:'技能未知',
  你猜:'你猜',
  博士及以上:'博士及以上',
  大专及同等学历:'大专及同等学历',
  '硕士/研究生':'硕士/研究生',
  '本科/学士':'本科/学士',
  其他:'其他',
  参加竞赛:'参加竞赛',
  可参加:'可参加',
  得分:'得分',
  暂无成绩:'暂无成绩',
  排名:'排名',
  获得成就:'获得成就',
  名次:'名次',
  奖励:'奖励',
    邀请赛:'邀请赛',
    专题赛:'专题赛',
    全部:'全部',
    已结束:'已结束',
}



//////////////////
// WEBPACK FOOTER
// ./static/js/lang/zh.js
// module id = vQuA
// module chunks = 55